import { render } from "./SensorsAdminComponent.vue?vue&type=template&id=54287efc"
import script from "./SensorsAdminComponent.vue?vue&type=script&lang=js"
export * from "./SensorsAdminComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__